// extracted by mini-css-extract-plugin
export default {"verifyNumberContainer":"verifyNumber_verifyNumberContainer__HZ5jI","stepNumberContainer":"verifyNumber_stepNumberContainer__egp2B"};